import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { IAircraftModel } from '../aircraft-models.types';

@Component({
	selector: 'app-aircraft-models-card',
	templateUrl: './aircraft-models-card.component.html',
	styleUrls: ['./aircraft-models-card.component.scss']
})
export class AircraftModelsCardComponent implements OnInit {
	constructor(private router: Router) {}

	@Input() public aircraftModel: IAircraftModel;
	@Input() public isArchived: boolean;

	public ngOnInit(): void {}

	public navigate(id: string): void {
		this.router.navigate(['/pilotpay/aircraft-models/details', id]);
	}

	public navigateArchived(id: string): void {
		this.router.navigate(['/pilotpay/aircraft-models/details/archived', id]);
	}
}
